var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid mb-5",
      attrs: { id: "automation-container" },
    },
    [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-12 form-page px-md-5" },
          [
            _c("page-header", {
              attrs: {
                subtitle: _vm.$t("automations.viewAndManageYourAutomations"),
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "page-header pendo--badge-target-wrapper",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("automations.viewAutomations")) +
                              "\n            "
                          ),
                          _c(
                            "span",
                            { attrs: { id: "automation-tooltip" } },
                            [
                              _c("icon", {
                                staticClass: "tooltip-info",
                                attrs: { name: "question-circle" },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("automation-level-tabs"),
                    _vm._v(" "),
                    _vm.loading
                      ? _c("automations-loader")
                      : _c("router-view", { key: _vm.$route.name }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }